import { useState } from "react";
export const useResetPassword = () => {

  const [rstErr, setError] = useState(null)
  const [succ, setSucc] = useState(null)

  const resetPassword = async (email) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    
      body: JSON.stringify({ email })
    })
    const json = await response.json()

    if (!response.ok) {
      setError(json.error)
    }
    if (response.ok) {
      setSucc(json)
    }
  }

  //verify token
  const verifyToken = async ( emailToken) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/verify-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({  emailToken })

    })
    return response
  }

  const sendResetPassReq = async ( emailToken, password) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/reset-user-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({  emailToken, password })

    })

    return response
  }
  return { resetPassword, rstErr, succ, sendResetPassReq, verifyToken };
}

